import { customElement } from "lit/decorators.js";
import { Chart, type ChartDefinition } from "../Chart";

@customElement("s-tail-latency-chart")
export class TailLatencyChart extends Chart {
	protected override readonly definition: ChartDefinition = {
		title: "95th and 99th percentile latency",
		summary:
			"Round robin's tail latency rises sharply. Weighted round robin stays lowest, while least connections remains stable but slightly higher.",
		xMinimum: 0,
		xMaximum: 59,
		xTickStep: 4,
		yMinimum: 0,
		yMaximum: 4000,
		xAxisTitle: "Time elapsed (seconds)",
		yAxisTitle: "Response time (ms)",
		series: [
			{
				name: "Round Robin (RR) 95%ile",
				points: [
					{ x: 0, y: 524.979 },
					{ x: 1, y: 1478.691 },
					{ x: 2, y: 1231.201 },
					{ x: 3, y: 1635.351 },
					{ x: 5, y: 1860.759 },
					{ x: 6, y: 1936.589 },
					{ x: 8, y: 1848.694 },
					{ x: 10, y: 2036.169 },
					{ x: 13, y: 2049.085 },
					{ x: 14, y: 2111.874 },
					{ x: 16, y: 2439.902 },
					{ x: 21, y: 2282.332 },
					{ x: 23, y: 2339.753 },
					{ x: 25, y: 2473.234 },
					{ x: 26, y: 2449.902 },
					{ x: 27, y: 2493.234 },
					{ x: 40, y: 2264.909 },
					{ x: 49, y: 2391.571 },
					{ x: 53, y: 2499.9 },
					{ x: 58, y: 2543.208 },
					{ x: 59, y: 2541.8 },
				],
				color: "var(--chart-orange)",
				legendLabel: "Round Robin",
			},
			{
				name: "Round Robin (RR) 99%ile",
				points: [
					{ x: 0, y: 524.979 },
					{ x: 1, y: 1775.679 },
					{ x: 2, y: 1726.181 },
					{ x: 5, y: 2056.644 },
					{ x: 9, y: 2067.208 },
					{ x: 10, y: 2202.345 },
					{ x: 11, y: 2180.205 },
					{ x: 14, y: 2782.076 },
					{ x: 41, y: 2677.508 },
					{ x: 42, y: 2733.974 },
					{ x: 47, y: 2712.392 },
					{ x: 54, y: 2849.053 },
					{ x: 56, y: 2957.215 },
					{ x: 57, y: 3185.836 },
					{ x: 58, y: 3192.027 },
					{ x: 59, y: 3191.984 },
				],
				color: "var(--chart-orange)",
				showInLegend: false,
			},
			{
				name: "Weighted Round Robin (WRR) 95%ile",
				points: [
					{ x: 0, y: 671.64 },
					{ x: 1, y: 1831.177 },
					{ x: 2, y: 1892.424 },
					{ x: 5, y: 1586.895 },
					{ x: 8, y: 1542.767 },
					{ x: 11, y: 1641.601 },
					{ x: 17, y: 1592.981 },
					{ x: 18, y: 1629.935 },
					{ x: 20, y: 1579.286 },
					{ x: 22, y: 1638.268 },
					{ x: 27, y: 1549.123 },
					{ x: 28, y: 1591.186 },
					{ x: 35, y: 1533.637 },
					{ x: 36, y: 1594.936 },
					{ x: 38, y: 1545.863 },
					{ x: 40, y: 1557.438 },
					{ x: 41, y: 1630.768 },
					{ x: 45, y: 1568.687 },
					{ x: 46, y: 1624.935 },
					{ x: 48, y: 1624.935 },
					{ x: 51, y: 1549.105 },
					{ x: 59, y: 1533.09 },
				],
				color: "var(--chart-blue)",
				texture: "dashed",
				legendLabel: "Weighted Round Robin",
			},
			{
				name: "Weighted Round Robin (WRR) 99%ile",
				points: [
					{ x: 0, y: 680.973 },
					{ x: 1, y: 2052.835 },
					{ x: 2, y: 2065.084 },
					{ x: 14, y: 1799.595 },
					{ x: 20, y: 1791.595 },
					{ x: 22, y: 1865.592 },
					{ x: 35, y: 1816.594 },
					{ x: 36, y: 1857.592 },
					{ x: 40, y: 1842.593 },
					{ x: 41, y: 1888.591 },
					{ x: 59, y: 1824.51 },
				],
				color: "var(--chart-blue)",
				texture: "dashed",
				showInLegend: false,
			},
			{
				name: "Least Connections (LC) 95%ile",
				points: [
					{ x: 0, y: 949.962 },
					{ x: 3, y: 1904.924 },
					{ x: 4, y: 1829.927 },
					{ x: 5, y: 1907.734 },
					{ x: 8, y: 1646.619 },
					{ x: 14, y: 1568.961 },
					{ x: 17, y: 1631.578 },
					{ x: 21, y: 1642.851 },
					{ x: 30, y: 1605.631 },
					{ x: 59, y: 1616.602 },
				],
				color: "var(--chart-green)",
				texture: "dotted",
				legendLabel: "Least Connections",
			},
			{
				name: "Least Connections (LC) 99%ile",
				points: [
					{ x: 0, y: 949.962 },
					{ x: 1, y: 1488.107 },
					{ x: 2, y: 1631.268 },
					{ x: 3, y: 2026.919 },
					{ x: 16, y: 1940.492 },
					{ x: 17, y: 2022.919 },
					{ x: 19, y: 2007.92 },
					{ x: 21, y: 2057.084 },
					{ x: 40, y: 2040.668 },
					{ x: 51, y: 1969.171 },
					{ x: 52, y: 2042.418 },
					{ x: 59, y: 2046.501 },
				],
				color: "var(--chart-green)",
				texture: "dotted",
				showInLegend: false,
			},
		],
	};
}
